'use client'
import Image from 'next/image'
import { useState } from 'react'

import SkeletonImage from '@/shared/components/slider/components/SkeletonImage'
import type { SlideItem } from '@/shared/components/slider/view'

interface TicketPhotoItemProps {
  item: SlideItem
  setCurrentSlide: React.Dispatch<React.SetStateAction<number>>
  imgIndex: number
}

const TicketPhotoItem = ({ item, setCurrentSlide, imgIndex }: TicketPhotoItemProps) => {
  const [isLoaded, setIsLoaded] = useState(false)
  return (
    <div className="relative h-[100px] w-[140px] cursor-pointer rounded-md border border-030">
      {!isLoaded && <SkeletonImage />}
      <Image
        alt="주차장 사진"
        src={'fileName' in item ? item.fileName : ''}
        sizes="140px"
        fill
        style={{
          objectFit: 'cover',
          borderRadius: '6px'
        }}
        placeholder="empty"
        onLoad={() => setIsLoaded(true)}
        onClick={() => setCurrentSlide(imgIndex)}
        draggable={true}
      />
    </div>
  )
}

export default TicketPhotoItem
